import { IProduct, Product } from './product';
import { IAddress, Address } from './../address';

export interface ICredentialVerification extends IProduct {
    agencyId: string;
    sendTo: IAddress;
    sendToType: string;
    activePrice: number;
    inactivePrice: number;
}

export class CredentialVerification extends Product implements ICredentialVerification {
    agencyId = null;
    sendTo = new Address();
    sendToType = null;
    activePrice = null;
    inactivePrice = null;
}